// Exports
export default {
	"oneColLayout": "oneColLayout_jkjgJ"
};
